import React, { useState } from "react";
import Button, { ButtonType } from "../Assets/Button";
import { ITaskManagement } from "../../models/taskManagement.model";
import toast from "react-hot-toast";

interface DuplicateTaskManagerModalProps {
  isOpen: boolean;
  onClose: () => void;
  tasks: ITaskManagement[];
  currentTaskId: string | null;
  onConfirm: (
    currentTaskId: string,
    duplicateOfTaskId: string,
    remark: string
  ) => void;
}

const DuplicateTaskManagerModal: React.FC<DuplicateTaskManagerModalProps> = ({
  isOpen,
  onClose,
  tasks,
  currentTaskId,
  onConfirm,
}) => {
  const [selectedTaskId, setSelectedTaskId] = useState<string>("");
  const [remark, setRemark] = useState<string>("");

  if (!isOpen) return null;

  const handleDuplicateTask = () => {
    if (!selectedTaskId) {
      toast.error("Select a task to mark as duplicate");
      return;
    }
    if (selectedTaskId === currentTaskId) {
      toast.error("Cannot mark a task as duplicate of itself");
      return;
    }
    if (!remark.trim()) {
      toast.error("Please enter a remark");
      return;
    }
    onConfirm(currentTaskId!, selectedTaskId, remark);
    setSelectedTaskId("");
    setRemark("");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-sm font-medium mb-4">Mark Task As Duplicate</h2>

        <label className="block mb-2 text-xs text-gray-700">Select Task</label>
        <select
          className="w-full p-2 border border-gray-300 rounded-md mb-4 text-xs"
          value={selectedTaskId}
          onChange={(e) => setSelectedTaskId(e.target.value)}
        >
          <option value="">Select task to mark as duplicate</option>
          {tasks
            .filter((task) => task._id !== currentTaskId)
            .map((task) => (
              <option key={task._id} value={task._id}>
                {task.taskName} {task._id === currentTaskId ? "(original)" : ""}
              </option>
            ))}
        </select>

        <label className="block mb-2 text-xs text-gray-700">Remark</label>
        <textarea
          className="w-full p-2 border border-gray-300 rounded-md mb-4 text-xs resize-none"
          rows={3}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          placeholder="Enter reason for marking as duplicate..."
        />

        <div className="flex justify-end space-x-2">
          <Button
            type={ButtonType.Cancel}
            onClick={onClose}
            className="text-xs"
          >
            Cancel
          </Button>
          <Button
            type={ButtonType.Submit}
            onClick={handleDuplicateTask}
            className="text-xs"
          >
            Duplicate
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateTaskManagerModal;
